/**
 * VyV BackOffice API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CrossSellingInformationVm } from '../model/crossSellingInformationVm';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from 'src/environments/environment';
import { SaveCrossSellingQuestionsCommand } from '../model/saveCrossSellingQuestionsCommand';



@Injectable({
  providedIn: 'root'
})
export class CrossSellingService {

    protected basePath = environment.apiV2RootUrl;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

     /**
     * @param agreementId
     * @param salesChannel
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCrosssellingsAgreementAgreementIdQuestionsGet(agreementId: string, salesChannel: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CrossSellingInformationVm | null>;
    public apiCrosssellingsAgreementAgreementIdQuestionsGet(agreementId: string, salesChannel: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CrossSellingInformationVm | null>>;
    public apiCrosssellingsAgreementAgreementIdQuestionsGet(agreementId: string, salesChannel: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CrossSellingInformationVm | null>>;
    public apiCrosssellingsAgreementAgreementIdQuestionsGet(agreementId: string, salesChannel: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (agreementId === null || agreementId === undefined) {
            throw new Error('Required parameter agreementId was null or undefined when calling apiCrosssellingsAgreementAgreementIdQuestionsGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/crosssellings/agreement/${this.configuration.encodeParam({name: "agreementId", value: agreementId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/questions/salesChannel/${this.configuration.encodeParam({name: "salesChannel", value: salesChannel, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        localVarPath = localVarPath.replace('/api', '');
        return this.httpClient.request<CrossSellingInformationVm | null>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
         * @param saveCrossSellingQuestionsCommand
         * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
         * @param reportProgress flag to report request and response progress.
         */
        public apiCrosssellingAnswsersPatch(saveCrossSellingQuestionsCommand: SaveCrossSellingQuestionsCommand, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
        public apiCrosssellingAnswsersPatch(saveCrossSellingQuestionsCommand: SaveCrossSellingQuestionsCommand, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
        public apiCrosssellingAnswsersPatch(saveCrossSellingQuestionsCommand: SaveCrossSellingQuestionsCommand, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
        public apiCrosssellingAnswsersPatch(saveCrossSellingQuestionsCommand: SaveCrossSellingQuestionsCommand, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
            if (saveCrossSellingQuestionsCommand === null || saveCrossSellingQuestionsCommand === undefined) {
                throw new Error('Required parameter saveCrossSellingQuestionsCommand was null or undefined when calling apiCrosssellingAnswsersPatch.');
            }

            let localVarHeaders = this.defaultHeaders;

            let localVarCredential: string | undefined;
            // authentication (Bearer) required
            localVarCredential = this.configuration.lookupCredential('Bearer');
            if (localVarCredential) {
                localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
            }

            let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
            if (localVarHttpHeaderAcceptSelected === undefined) {
                // to determine the Accept header
                const httpHeaderAccepts: string[] = [
                ];
                localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
            }
            if (localVarHttpHeaderAcceptSelected !== undefined) {
                localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
            }

            let localVarHttpContext: HttpContext | undefined = options && options.context;
            if (localVarHttpContext === undefined) {
                localVarHttpContext = new HttpContext();
            }

            let localVarTransferCache: boolean | undefined = options && options.transferCache;
            if (localVarTransferCache === undefined) {
                localVarTransferCache = true;
            }


            // to determine the Content-Type header
            const consumes: string[] = [
                'application/json'
            ];
            const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
            if (httpContentTypeSelected !== undefined) {
                localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
            }

            let responseType_: 'text' | 'json' | 'blob' = 'json';
            if (localVarHttpHeaderAcceptSelected) {
                if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                    responseType_ = 'text';
                } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                    responseType_ = 'json';
                } else {
                    responseType_ = 'blob';
                }
            }

            let localVarPath = `/api/crosssellings/answers`;
            localVarPath = localVarPath.replace('/api', '');
            return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`,
                {
                    context: localVarHttpContext,
                    body: saveCrossSellingQuestionsCommand,
                    responseType: <any>responseType_,
                    withCredentials: this.configuration.withCredentials,
                    headers: localVarHeaders,
                    observe: observe,
                    transferCache: localVarTransferCache,
                    reportProgress: reportProgress
                }
            );
        }
}
